module.exports = __webpack_public_path__ + "static/media/icon-lock.80a22121.svg";